/**
 * Formats a business / agency / team (product) name for display.
 *
 * When the entity has a `display_name` that differs from its `name`, both are
 * shown as `name (display_name)`. Otherwise just the name is returned. Use this
 * everywhere these entities surface — dropdown options, lists, chips, headers —
 * so the rendering stays consistent across the app.
 */
export interface NamedEntity {
  name?: string;
  display_name?: string;
}

export const formatEntityName = (entity?: NamedEntity | null): string => {
  const name = entity?.name?.trim() ?? "";
  const display = entity?.display_name?.trim() ?? "";
  if (display && display !== name) {
    return name ? `${name} (${display})` : display;
  }
  return name;
};
